import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import Card, { CardItem } from './Card';
import { CustomerEmail } from './CustomerEmail';
import { DownloadOutlined } from "@ant-design/icons";
import ApplicationService from '../../../services/ApplicationService';
import { getDocumentTypeText, getPhoto, getUrlPath } from '../../../helpers/parsers';

const CustomerInfo = ({uuId, appState, customer, setApplication}) => {
    const { firstName, lastName, email, phoneNumber, customerDocument, emailVerified } = customer;
    const { filePath, name: fileName } = getPhoto(customer) || {};

    const getImage = (url) => {
        ApplicationService.getPdf(getUrlPath(url))
            .then(response => response.blob())
            .then(data => {
                let newWindow = window.open('');
                newWindow.location.href = URL.createObjectURL(data);
                newWindow.focus();
            })
    }

    return (
        <div>
            <Card title='Անձնական տվյալներ'>
                <Row>
                    <Col span={6}>
                        <CardItem name='Անուն' value={firstName || '-'}/>
                    </Col>
                    <Col span={6}>
                        <CardItem name='Ազգանուն' value={lastName || '-'}/>
                    </Col>
                    <Col span={6}>
                        <CustomerEmail
                          uuId={uuId}
                          email={email || ''}
                          setApplication={setApplication}
                          emailVerified={!!emailVerified}
                        />
                    </Col>
                    <Col span={6}>
                        <CardItem name='Անձը հաստատող փաստ.' value={getDocumentTypeText(customerDocument.type)}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <CardItem name='Փաստաթղթի համար' value={customerDocument.number || '-'}/>
                    </Col>
                    <Col span={6}>
                        <CardItem name='Հեռախոսահամար' value={phoneNumber || '-'}/>
                    </Col>
                    <Col span={6}>
                        <CardItem name='Լուսանկար' value={
                            <div style={{ color: '#510f9a', cursor: 'pointer' }} onClick={() => getImage(filePath)}>
                                <DownloadOutlined style={{ marginRight: '8px' }} />
                                {fileName}
                            </div>
                        }/>
                    </Col>
                </Row>
            </Card>
        </div>
    )
};

CustomerInfo.propTypes = {
    uuId: PropTypes.string.isRequired,
    appState: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    setApplication: PropTypes.func.isRequired,
};

export default CustomerInfo;